<template>
  <section class="section">
    <div style="text-align: center; font-weight: bold; margin-bottom: 15px">
      {{ $l("components.configurationUpdate.createVersion", "Create Version") }}
    </div>

    <div style="display: flex; justify-content: center">
      <div class="stepper-wrapper">
        <div class="stepper-item" :class="{ active: step === 1, completed: step === 2 }">
          <div class="step-counter"></div>
          <div class="step-name">
            {{ $l("components.configurationUpdate.basic", "Basic") }}
          </div>
        </div>
        <div class="stepper-item" :class="{
        active: step === 2,
      }">
          <div class="step-counter"></div>
          <div class="step-name">
            {{ $l("components.configurationUpdate.uploadFile", "Upload File") }}
          </div>
        </div>
      </div>
    </div>

    <div style="display: flex; justify-content: center">
      <box style="width: 85%">
        <div class="p-4">
          <Form v-if="step === 1" ref="form" :model="form" :rules="ruleValidate" label-position="top">
            <FormItem ref="version" prop="version">
              <template slot="label">
                <strong>{{
        $l("components.configurationUpdate.version", "Version")
      }}</strong>
              </template>

              <Input v-model="form.version" :placeholder="$l('components.configurationUpdate.enterName', 'Enter name')
        " />
            </FormItem>

            <FormItem v-if="this.form.type">
              <p style="color: #c0c0c0">
                {{
        $l(
          "components.configurationUpdate.currentVersion",
          "Current Version"
        ) +
        ": " +
        (!latestVersion
          ? $l(
            "components.configurationUpdate.noVersion",
            "No version has been created yet"
          )
          : latestVersion)
      }}
              </p>
            </FormItem>

            <FormItem ref="type" prop="type" style="width: 50%">
              <template slot="label">
                <strong>{{
          $l("components.configurationUpdate.type", "Type")
        }}</strong>
              </template>

              <Select v-model="form.type">
                <Option v-for="item in listTypes" :value="item.value" :key="item.value">{{ item.name }}</Option>
              </Select>
            </FormItem>

            <FormItem ref="tagIDs" prop="tagIDs">
              <template slot="label">
                <strong>{{
        $l("components.configurationUpdate.tags", "Tags")
      }}</strong>
              </template>

              <Select v-model="form.tagIDs" multiple :placeholder="$l('components.configurationUpdate.tags', 'Tags')">
                <Option v-for="item in listTags" :value="item.id" :key="item.id">{{ item.name }}</Option>
              </Select>
            </FormItem>

            <FormItem ref="description" prop="description">
              <template slot="label">
                <strong>{{
        $l(
          "components.configurationUpdate.description",
          "Description"
        )
      }}</strong>
              </template>

              <Input v-model="form.description" type="textarea" :autosize="{ minRows: 5, maxRows: 10 }" :placeholder="$l(
        'components.configurationUpdate.description',
        'Description'
      )
        " />
            </FormItem>

            <FormItem>
              <div class="field is-grouped is-grouped-right">
                <div class="control">
                  <Button style="margin-right: 8px" @click="handleClickCancel">{{ $l("global.cancel", "Cancel")
                    }}</Button>
                </div>
                <div class="control">
                  <Button type="primary" @click="handleClickNext('form')">
                    {{ $l("global.next", "Next") }}</Button>
                </div>
              </div>
            </FormItem>
          </Form>

          <!--  -->

          <Form v-if="step === 2" ref="form" :model="form" :rules="ruleValidate" label-position="top">
            <FormItem v-for="(item, i) in this.listOSTemp" :key="i">
              <Row>
                <Col span="5">
                <strong>{{ item.name }}</strong>
                </Col>

                <Col span="12">
                <div class="file" :class="{
        'file-error':
          checkErrorFile(item) === 0 ||
          checkErrorFile(item) === 1 ||
          checkErrorFile(item) === 2 ||
          checkErrorFile(item) === 3 ||
          checkErrorFile(item) === 4,
      }">
                  <label class="file-label" style="width: 100%">
                    <input class="file-input" type="file" name="resume" @change="onFileChange(item)" />
                    <span class="file-cta" style="
                          width: 100%;
                          display: flex;
                          justify-content: space-between;
                          background-color: #fff;
                        ">
                      <span class="file-label">
                        {{
        item.file && item.file.name && !item.replacementFile
          ? item.file.name
          : item.replacementFile
            ? item.replacementFile.name
            : "Choose a file ..."
      }}</span>
                      <span class="file-icon">
                        <Icon type="ios-attach" size="25" />
                      </span>
                    </span>
                  </label>
                </div>

                <p v-if="checkErrorFile(item) === 0 ||
        checkErrorFile(item) === 1 ||
        checkErrorFile(item) === 2 ||
        checkErrorFile(item) === 3 ||
        checkErrorFile(item) === 4
        " style="position: absolute; bottom: -24px; color: red">
                  {{
        checkErrorFile(item) === 0
          ? $l(
            "components.configurationUpdate.fileValidFormat",
            "The format is not supported"
          )
          : checkErrorFile(item) === 1
            ? $l(
              "components.configurationUpdate.fileUploadError",
              "File upload error"
            )
            : checkErrorFile(item) === 2
              ? $l(
                "components.configurationUpdate.fileBiggerThan300M",
                "Please download files with a capacity of less than 300 MB"
              )
              : checkErrorFile(item) === 3
                ? $l(
                  "components.configurationUpdate.cannotBeLeftBlank",
                  "Cannot be left blank"
                )
                : checkErrorFile(item) === 4
                  ? $l(
                    "components.configurationUpdate.fileModified",
                    "The file has been modified on your computer"
                  )
                  : ""
      }}
                </p>
                </Col>

                <Col span="7">
                <div style="display: flex; justify-content: center">
                  <span style="font-weight: bold" :class="{
          'status-init': item.uploadStatus === 0,
          'status-ready': item.uploadStatus === 1,
          'status-error': item.uploadStatus === 2,
        }">{{ renderUploadStatus(item) }}</span>

                  <span v-if="item.uploadStatus === 2" class="ml-2 icon-error"
                    @click="handleClickReuploadErrorFile(item.id)">
                    <Icon type="ios-cloud-upload-outline" size="23" color="red" />
                  </span>

                  <span v-if="item.uploadStatus === 2" class="ml-2 icon-error"
                    @click="handleClickCloseErrorFile(item.id)">
                    <Icon type="ios-close-circle-outline" size="23" color="red" />
                  </span>
                </div>
                </Col>
              </Row>
            </FormItem>

            <FormItem ref="supportedOSList" prop="supportedOSList">
              <template slot="label">
                <strong>{{
        $l(
          "components.configurationUpdate.supportedOSList",
          "Supported OS List"
        )
      }}</strong>
              </template>

              <Select class="supported-os-list" v-model="form.supportedOSList" multiple :disabled="loading"
                :placeholder="$l(
        'components.configurationUpdate.supportedOSList',
        'Supported OS List'
      )
        ">
                <Option v-for="item in listOS" :value="item.id" :key="item.id" :disabled="checkDisabledOption(item.id)"
                  :clearable="false">{{ item.name }}
                </Option>
              </Select>
            </FormItem>

            <FormItem>
              <div class="field is-grouped is-grouped-right">
                <div class="control">
                  <Button style="margin-right: 8px" @click="handleClickCancel">{{ $l("global.cancel", "Cancel")
                    }}</Button>
                </div>
                <div class="control">
                  <Button :loading="loading" type="primary" @click="handleClickUpload('form')">
                    {{ $l("global.upload", "Upload") }}</Button>
                </div>

                <div class="control">
                  <Button type="success" :disabled="loading || checkCanComplete()" @click="handleClickComplete">
                    {{ $l("global.complete", "Compelete") }}</Button>
                </div>
              </div>
            </FormItem>
          </Form>
        </div>
      </box>
    </div>
  </section>
</template>

<script>
import UpdateApi from "@/api/Update";
import { plus, kebabHorizontal, cloudUpload } from "octicons-vue";
import { Tabs, Tab, DataTable, DataColumn, Modal } from "@cyradar/ui";
import SvgIcon from "@jamescoyle/vue-icon";
import vSelect from "vue-select";
import SparkMD5 from "spark-md5";

import {
  Form,
  FormItem,
  Input,
  Select,
  Option,
  Button,
  Row,
  Col,
  Upload,
  Icon,
} from "iview";

import { mdiFilter } from "@mdi/js";
export default {
  components: {
    Tabs,
    Tab,
    DataTable,
    DataColumn,
    Modal,
    SvgIcon,
    vSelect,
    Form,
    FormItem,
    Input,
    Select,
    Option,
    Button,
    Row,
    Col,
    Upload,
    Icon,
  },

  data() {
    return {
      path: mdiFilter,
      cloudUpload,
      plus,
      kebabHorizontal,

      step: 1,
      form: { type: "basic_engine", tagIDs: [], supportedOSList: [] },
      senddingForm: {},

      listTags: [],
      listOS: [],
      listOSTemp: [],

      listRepo: [],

      listTypes: [
        {
          value: "basic_engine",
          name: "Basic Engine",
        },
        {
          value: "installer_online",
          name: "Online Installer",
        },
        {
          value: "installer_offline",
          name: "Offline Installer",
        },
        {
          value: "db_hash",
          name: "Hash Database",
        },
        {
          value: "db_signature",
          name: "Signature Database",
        },
        {
          value: "db_resource",
          name: "Resource Database",
        },
        {
          value: "advance_engine",
          name: "Advance Engine",
        },
      ],

      latestVersion: "",

      loading: false,
      isClickedUpload: false,
    };
  },
  watch: {
    "form.type"(newValue) {
      this.getLatestVersion(newValue);
    },

    "form.supportedOSList"(newValue) {
      if (newValue.length < this.listOSTemp.length) {
        this.listOSTemp.forEach((item) => {
          if (!newValue.find((e) => e === item.id)) {
            this.listOSTemp = this.listOSTemp.filter((os) => os !== item);
          }
        });
      } else {
        newValue.forEach((item) => {
          if (!this.listOSTemp.find((e) => e.id === item)) {
            this.listOSTemp.push({
              id: item,
              name: this.renderOSName(item),
              file: null,
              uploadStatus: 0,
              isFileLocalModified: false,
            });
          }
        });
      }
    },
  },

  computed: {
    // Form 1 rule
    defaultRule() {
      return {
        required: true,
        message: this.$l(
          "components.configurationUpdate.cannotBeLeftBlank",
          "Cannot be left blank"
        ),
        trigger: "blur",
      };
    },

    ruleValidate() {
      return {
        version: [
          this.defaultRule,
          {
            type: "string",
            validator: this.checkValidVersion,
            required: true,
            trigger: "blur",
          },
        ],

        type: [this.defaultRule],

        tagIDs: [
          {
            type: "array",
            validator: this.checkValidTags,
            required: true,
            trigger: "change",
          },
        ],

        supportedOSList: [
          {
            type: "array",
            validator: this.checkValidSupportedOSList,
            required: true,
            trigger: "change",
          },
        ],
      };
    },
  },
  methods: {
    renderOSName(val) {
      const x = this.listOS.find((os) => os.id === val);

      if (!x) {
        return;
      }

      return x.name;
    },

    checkDisabledOption(os) {
      const x = this.renderRepoID(os);
      if (!x) {
        return false;
      }

      return true;
    },

    // Choose file

    onFileChange(item) {
      const file = event.target.files[0];
      item.file = file;

      item.isFileLocalModified = false;

      if (item.file && (item.uploadStatus === 1 || item.uploadStatus === 2)) {
        item.isHadNewFile = true;
      }
    },

    checkFileType(name) {
      const extension = name.split(".").pop().toLowerCase();
      switch (extension) {
        case "exe":
          return true;
        case "zip":
          return true;
        case "deb":
          return true;
        case "rpm":
          return true;
        case "bin":
          return true;
        default:
          return false;
      }
    },

    checkErrorFile(item) {
      if (item.file && item.file.name && !this.checkFileType(item.file.name)) {
        return 0; // 0 là sai type
      }

      if (item.file && item.file.name && item.uploadStatus === 2) {
        return 1; // 1 là upload lỗi
      }

      if (item.file && item.file.size / 1000000 > 300) {
        return 2; // 2 là file quá 300M
      }

      if (!item.file && this.isClickedUpload) {
        return 3; // 3 là để trống chọn file
      }

      if (item.file && item.isFileLocalModified) {
        return 4; // 4 là file đã bị thay đổi trên desktop
      }

      return;
    },

    renderUploadStatus(item) {
      if (item.uploadStatus === 0) {
        return this.$l(
          "components.configurationUpdate.initializing",
          "Initializing"
        );
      } else {
        if (item.uploadStatus === 1) {
          return this.$l("components.configurationUpdate.ready", "Ready");
        } else {
          if (item.uploadStatus === 2) {
            return this.$l("components.configurationUpdate.error", "Error");
          }
        }
      }
    },

    // Check valid

    checkCanComplete() {
      const x = this.listOSTemp.find((item) => item.uploadStatus !== 1);

      if (!x) {
        return false;
      }

      return true;
    },

    checkValidVersion(rule, value, callback) {
      if (value.length < 3 || value.length > 256) {
        callback(
          new Error(
            this.$l(
              "components.configurationUpdate.versionValidLength",
              "The version must have a length ranging from 3 to 256 characters"
            )
          )
        );
      } else {
        if (value === this.latestVersion) {
          callback(
            new Error(
              this.$l(
                "components.configurationUpdate.versionValidDuplication",
                "This version already exists"
              )
            )
          );
        } else {
          const regex = /^[a-zA-Z0-9_.]+$/;
          if (!regex.test(value)) {
            callback(
              new Error(
                this.$l(
                  "components.configurationUpdate.versionValidFormat",
                  "The version cannot contain spaces and can only include alphanumeric characters, dots (.), or underscores (_)"
                )
              )
            );
          } else {
            callback();
          }
        }
      }
    },

    checkValidTags(rule, value, callback) {
      if (!value.length) {
        callback(
          new Error(
            this.$l(
              "components.configurationUpdate.cannotBeLeftBlank",
              "Cannot be left blank"
            )
          )
        );
      } else {
        callback();
      }
    },

    checkValidSupportedOSList(rule, value, callback) {
      if (!value.length) {
        callback(
          new Error(
            this.$l(
              "components.configurationUpdate.cannotBeLeftBlank",
              "Cannot be left blank"
            )
          )
        );
      } else {
        callback();
      }
    },

    // Create version
    saveVersion() {
      UpdateApi.addVersion(this.$http, {
        version: this.form.version,
        type: this.form.type,
        tagIDs: this.form.tagIDs,
        description: this.form.description,
      }).then((res) => {
        this.$store.dispatch("NOTIFY", {
          type: "success",
          text: res.message,
          duration: 10000,
        });

        this.step = 2;
      });
    },

    // Fetch

    async fetchTags() {
      await UpdateApi.getTagList(this.$http).then((data) => {
        this.listTags = data.map((tag) => {
          return { name: tag.name, id: tag._id };
        });
      });

      this.form.tagIDs = this.listTags.map((item) => item.id);
    },

    async fetchOS() {
      await UpdateApi.getActiveOSList(this.$http).then((data) => {
        this.listOS = data.map((os) => {
          return { name: os.name, id: os._id };
        });
      });

      this.form.supportedOSList = this.listOS.map((item) => item.id);
      this.listOSTemp = this.listOS.map((item) => {
        return {
          ...item,
          file: null,
          uploadStatus: 0,
          isHadNewFile: false,
          isFileLocalModified: false,
        };
      });
    },

    getLatestVersion(type) {
      if (type) {
        UpdateApi.latestVersion(this.$http, type)
          .then((res) => {
            this.latestVersion = res.version;
          })
          .catch(() => {
            this.latestVersion = "";
          });
      } else {
        return;
      }
    },

    // Create repo

    async saveRepo() {
      let os = this.form.supportedOSList;

      for (const item of os) {
        if (this.renderRepoID(item)) {
          os = os.filter((e) => e !== item);
        }
      }

      if (os.length > 0) {
        await UpdateApi.addRepo(this.$http, {
          version: this.form.version,
          type: this.form.type,
          os: os,
        }).then((res) => {
          this.$store.dispatch("NOTIFY", {
            type: "success",
            text: res.message || "Success add repo",
            duration: 10000,
          });

          this.listRepo = [...this.listRepo, ...res];

          this.beforeUploadFileRepo();
        });

        this.isClickedUpload = false;
      } else {
        this.beforeUploadFileRepo();
        this.isClickedUpload = false;
      }
    },

    // Upload repo

    renderRepoID(val) {
      const x = this.listRepo.find((repo) => repo.os === val);

      if (!x) {
        return;
      }

      return x._id;
    },

    async calculateFileHash(file) {
      return new Promise((resolve, reject) => {
        const chunkSize = 50 * 1024 * 1024;
        const blobSlice =
          File.prototype.slice ||
          File.prototype.mozSlice ||
          File.prototype.webkitSlice;
        const chunks = Math.ceil(file.size / chunkSize);
        let currentChunk = 0;
        const spark = new SparkMD5.ArrayBuffer();
        const fileReader = new FileReader();

        fileReader.onload = function (e) {
          spark.append(e.target.result);
          currentChunk++;

          if (currentChunk < chunks) {
            loadNext();
          } else {
            const hash = spark.end();
            resolve(hash);
          }
        };

        fileReader.onerror = function () {
          reject(null);
        };

        function loadNext() {
          const start = currentChunk * chunkSize;
          const end =
            start + chunkSize >= file.size ? file.size : start + chunkSize;
          const slice = blobSlice.call(file, start, end);
          fileReader.readAsArrayBuffer(slice);
        }

        loadNext();
      });
    },

    async beforeUploadFileRepo() {
      let temp = [];

      for (const item of this.listOSTemp) {
        if ((item.uploadStatus === 0 && item.file) || item.isHadNewFile) {
          const hash = await this.calculateFileHash(item.file);

          if (hash) {
            temp.push({
              hash: hash,
              os: item.id,
              file: item.file,
              repoID: this.renderRepoID(item.id),
            });
          }
        }
      }
      const sleep = ms => new Promise(res => setTimeout(res, ms));

      while (temp.length > 0) {
        const fileRepoTemp = temp.filter(
          (e) => e.hash === temp[0].hash && e.file.name === temp[0].file.name
        );

        temp = temp.filter(
          (e) => e.hash !== temp[0].hash || e.file.name !== temp[0].file.name
        );

        let os = [];
        let repoIDs = [];

        fileRepoTemp.map((item) => {
          repoIDs.push(item.repoID);
          os.push(item.os);
        });

        await this.uploadFileRepo(repoIDs, fileRepoTemp[0].file, os);
        await sleep(1000);
      }
    },

    async uploadFileRepo(repoIDs, file, os) {
      this.loading = true;

      const formData = new FormData();
      formData.append("file", file);
      formData.append("repoIDs", repoIDs.join());

      await UpdateApi.uploadRepoFile(this.$http, formData)
        .then((res) => {
          this.$store.dispatch("NOTIFY", {
            type: "success",
            text: res.message || "Success",
            duration: 1,
          });

          this.listOSTemp.map((item) => {
            if (os.find((e) => e === item.id)) {
              item.uploadStatus = 1;

              if (item.isHadNewFile) {
                item.isHadNewFile = false;
              }
            }
          });

          if (!this.listOSTemp.find((e) => e.uploadStatus === 0)) {
            this.loading = false;
            this.isClickedUpload = false;
          }
        })

        .catch((error) => {
          this.listOSTemp.map((item) => {
            if (os.find((e) => e === item.id)) {
              item.uploadStatus = 2;

              if (item.isHadNewFile) {
                item.isHadNewFile = false;
              }
            }
          });

          if (!this.listOSTemp.find((e) => e.uploadStatus === 0)) {
            this.loading = false;
            this.isClickedUpload = false;
          }
        });
    },

    // Handle Click

    handleClickNext(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.saveVersion();
        }
      });
    },

    async handleClickUpload(name) {
      this.isClickedUpload = true;

      this.$refs[name].validate(async (valid) => {
        if (valid) {
          let isError = false;
          for (const item of this.listOSTemp) {
            if (!item.file) {
              isError = true;
            }

            if ((item.uploadStatus === 0 && item.file) || item.isHadNewFile) {
              await this.calculateFileHash(item.file).catch(() => {
                item.isFileLocalModified = true;
                isError = true;
              });
            }

            if (
              this.checkErrorFile(item) === 0 ||
              this.checkErrorFile(item) === 1 ||
              this.checkErrorFile(item) === 2 ||
              this.checkErrorFile(item) === 4
            ) {
              isError = true;
            }
          }

          if (!isError) {
            this.loading = true;
            this.saveRepo();
          }
        }
      });
    },

    handleClickComplete() {
      UpdateApi.completeCreateVersion(this.$http, {
        version: this.form.version,
        type: this.form.type,
      }).then((res) => {
        this.$store.dispatch("NOTIFY", {
          type: "success",
          text: res.message || "Success",
          duration: 1,
        });

        this.$router.push({ name: "update" });
      });
    },

    handleClickCancel() {
      this.$router.push({ name: "update" });
    },

    handleClickReuploadErrorFile(os) {
      const repoID = this.renderRepoID(os);
      const x = this.listOSTemp.find((item) => item.id === os);

      if (!x) {
        return;
      }

      const formData = new FormData();
      formData.append("file", x.file);
      formData.append("repoIDs", [repoID]);

      UpdateApi.uploadRepoFile(this.$http, formData)
        .then((res) => {
          this.$store.dispatch("NOTIFY", {
            type: "success",
            text: res.message || "Success",
            duration: 1,
          });

          x.uploadStatus = 1;
        })

        .catch((error) => {
          x.uploadStatus = 2;
        });
    },

    handleClickCloseErrorFile(os) {
      const repoID = this.renderRepoID(os);
      UpdateApi.deleteRepo(this.$http, repoID).then((res) => {
        this.$store.dispatch("NOTIFY", {
          type: "success",
          text: res.message || "Success",
          duration: 1,
        });

        this.listOSTemp = this.listOSTemp.filter((item) => item.id !== os);
        this.form.supportedOSList = this.form.supportedOSList.filter(
          (item) => item !== os
        );
      });
    },

    // Check is root

    async checkIsRoot() {
      await UpdateApi.checkIsRoot(this.$http).then((res) => {
        if (res.data && res.data.product !== "root") {
          this.$router.push({ name: "update" });
        }
      });
    },
  },

  async mounted() {
    await this.checkIsRoot();
    await this.fetchTags();
    await this.getLatestVersion(this.form.type);
    await this.fetchOS();
  },
};
</script>
<style src="vue-select/dist/vue-select.css"></style>
<style lang="scss" scoped>
.file-error {
  border: 1px solid red;
  border-radius: 5px;
}

.status-init {
  color: #000;
}

.status-ready {
  color: #2096f2;
}

.status-error {
  color: red;
}

.icon-error:hover {
  opacity: 0.5;
  cursor: pointer;
}

.supported-os-list /deep/ .ivu-tag-checked {
  .ivu-icon.ivu-icon-ios-close {
    display: none !important;
  }
}
</style>
